import React from 'react';
import './ButtonVimeo.css';

const ButtonVimeo = (props) => {
  
    return (
 <a className="button-vimeo" href='https://vimeo.com/jozefdeville' target="_blank">
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.87 36.63"><g id="aeca7c54-1542-4d87-8fcb-3c2dea321b9f" data-name="Layer 2"><g id="e7acfec0-c971-48fc-9e61-8dbcd858844e" data-name="Layer 5"><path d="M35.75,0C30-.2,26,3.13,24,9.94a7.62,7.62,0,0,1,3.1-.69c2.12,0,3.07,1.22,2.81,3.63q-.18,2.2-2.81,6.4c-1.76,2.8-3.07,4.2-3.95,4.2-2.65,0-4.25-12.71-4.79-16.18Q17.2.07,12.31.54C9.32.82,4.1,6.21,0,9.86l2,2.56a12.7,12.7,0,0,1,3.28-2c3.26,0,4.84,11.1,7.38,19.36,1.7,4.56,3.74,6.84,6.2,6.84q5.93,0,14.46-11.22,8.25-10.76,8.53-16.93l0,0C42.08,2.94,40.07.12,35.75,0Z" fill="#fff"/></g></g></svg></a>
  )
}

export default ButtonVimeo;